import useClientOpportunity from '@modules/opportunities/entities/opportunity/query/useClientOpportunity';
import { NotFoundComponent } from '@modules/core/components/NotFoundComponent';
import { Skeleton } from '@mantine/core';
import { CaseCreationBanksFillFormsRoute } from '@modules/opportunities/presentation/routes';
import { BUSINESS_IDENTIFIER } from '@modules/core/api/const';
import useGetMissingBankApplicationsFields from '@modules/opportunities/entities/opportunity/query/useGetMissingBankApplicationsFields';
import useVaultData from '@modules/opportunities/entities/opportunity/query/useVaultData';
import {
  DocumentCategory,
  RequiredDocuments,
} from '@modules/opportunities/entities/opportunity/api/dto/vault.dto';
import { DOCUMENT_STATUS } from '@modules/opportunities/entities/opportunity/const';
import { BankForm } from './BankForm';

const isApplicantDocumentsValid = (documents: RequiredDocuments) => {
  const categoriesList = Object.keys(documents) as DocumentCategory[];

  const isAllUncategroizedValid = documents.uncategorized
    .filter((item) => item.id)
    .every(
      (item) =>
        item.status === DOCUMENT_STATUS.valid
      || item.status === DOCUMENT_STATUS.invalid
    );

  const isAllCategorizedValid = categoriesList
    .filter((item) => item !== 'uncategorized')
    .flatMap((category) =>
      documents[category].flatMap((item) =>
        item.documents.filter((doc) => doc.id)))
    .every((item) => DOCUMENT_STATUS.valid === item.status);

  return isAllUncategroizedValid && isAllCategorizedValid;
};

const CaseSubmissionFillBankForms = () => {
  const { opportunityId } = CaseCreationBanksFillFormsRoute.useParams();
  const { data: opportunityData, isLoading } = useClientOpportunity(opportunityId);
  const { data: missingBankApplicationFields, isRefetching } = useGetMissingBankApplicationsFields(opportunityId);
  const { data: vaultData, isLoading: isVaultDataLoading } = useVaultData(opportunityId);

  if (
    isLoading
    || !opportunityData
    || isRefetching
    || !missingBankApplicationFields
    || isVaultDataLoading
  ) {
    return (
      <>
        <Skeleton w='100%' height={ 500 } radius='8px' />
      </>
    );
  }

  if (
    APPLICATION_BUSINESS_IDENTIFIER === BUSINESS_IDENTIFIER.ES_BAYTECA
  ) {
    return <NotFoundComponent />;
  }

  const isAllDocumentValid = vaultData.applicants.every((item) =>
    isApplicantDocumentsValid(item.required_documents));

  if (APPLICATION_BUSINESS_IDENTIFIER === BUSINESS_IDENTIFIER.AE_HUSPY) {
    return (
      <BankForm
        applicants={ opportunityData?.opportunity.applicants! }
        missingFields={ missingBankApplicationFields }
        opportunity={ opportunityData.opportunity }
        isAllDocumentValid={ isAllDocumentValid }
      />
    );
  }
};

export default CaseSubmissionFillBankForms;
